import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ClientBO } from '../pages/client-parent/client-parent.model';
import { CommonHttpService } from '../common.service';
import { takeUntil } from 'rxjs/operators';
import { interval, Subject, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../service/general.service';
import { EmployeeBO } from '../pages/employee/employee.model';
import { SwUpdate } from '@angular/service-worker';
import { IframeCommunicationService } from '../service/iframe';
import { JwtHelper } from 'angular2-jwt';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { environment } from 'src/environments/environment.dev';

@Component({
  template: '',
})

export class GlobalComponent implements OnInit {
  public globalColumn: any = [];
  globalLocationList: any = [];
  selectedAgencyDropdown: any = [];
  selectedLocationDropdown: any = [];
  public LegStatusFilter: any = [];
  public DriverList: any = [];
  agencyId: any = ""
  public globalAgencyDropDown: any = [];
  public globalICD10List: any = [];
  public userRoleDropDown: any = [];
  public sideMenuItems: any = [];
  public ngAgencyDropDown: any = [];
  public ngLocationDropDown: any = [];
  public globalLocationDropDown: any = [];
  public globalFeatures: any = [];
  cxTenantDetails: any = null;
  globalclientdata: ClientBO = new ClientBO();
  globalemployeedata: EmployeeBO = new EmployeeBO();
  public userDetail: any = {};
  private onDestroy$: Subject<void> = new Subject<void>();
  CxCustomerName:any="";
  CxCustomerId:any="";
  refreshSubscription: Subscription;
  public agencyCode: string = "";
  public username: string = "";
  public roles: string = "";
  isassignboolean:boolean=false;
  public isClient: string;
  public OnboardType: string
  public portalAgencyCode: string
  public clientDocId: any;
  public clientagreementid: any;
  public employeeTemplateId: string | null;
  agencysName: string;
  public LoginEntityType: string;
  public onboardingId: string = "";
  public LoginTypeFields: string = "";
  public CFSS_onboardagencycode: string = "";
  public globalroleName: string;
  reporttype: string = "";
  reportday: number = 0;
  OnboardingLoginType: string = "";
  JwtHelper: JwtHelper = new JwtHelper();
  public isEditCustomer: boolean;
  public isEditAgent: boolean;
  public isEditCsp: boolean;
  public isEditAsset: boolean;
  public authtoken: string;
  public cfssLoginEntityId: string;
  public isEditUser: boolean;
  public globalHeadAgencyId: string;
  public loginType: string;
  viewTabs: boolean = false;
  viewEmployeeTabs: boolean = false;
  globalemployee: string = "00000000-0000-0000-0000-000000000000";
  interval: any
  isDashBoard: boolean
  isAgentOn: boolean;
  isAgentAdd: boolean;
  isAgentDel: boolean;
  isAgentEdit: boolean;
  isAgentUpdate: boolean;
  isAssetOn: boolean;
  isAssetAdd: boolean;
  isAssetDel: boolean;
  isAssetEdit: boolean;
  isAssetUpdate: boolean;
  isCustomerOn: boolean;
  isCustomerAdd: boolean;
  isCustomerDel: boolean;
  isCustomerEdit: boolean;
  isCustomerUpdate: boolean;
  isCspOn: boolean;
  isCspAdd: boolean;
  isCspDel: boolean;
  isCspEdit: boolean;
  isCspUpdate: boolean;
  isMapCsp: boolean;
  isBankService: boolean;
  isAccount: boolean;
  isCashIn: boolean;
  isCashOut: boolean;
  isFund: boolean;
  menu: boolean;
  cashin: boolean;
  cashout: boolean;
  fund: boolean;
  view: Boolean;
  calendarHeightdefault: string;
  calendarHeight: string;
  calendarHeight1: string;
  globalclaimfilter: any = null;
  editAgentId: string = "00000000-0000-0000-0000-000000000000";
  isViewEmployeefields: boolean = true;
  isclientportal: boolean
  isClientOnboard = false
  globalAgencyName: string
  onboardRoles: string;
  public apiKey: any;
  public otpuserId: any;
  public otp: any;
  public ResendEmail: any;
  public ResendAgencycode: any;
  public driverAdmin: any;
  public employee_ID: string;
  public group_Payor_ID: any;
  public security_Level: any;
  public docbool: boolean = false;
  public clientId: string;
  public userID: string;
  public globalClientmedicationId: string;
  public isWidgetLoaded = false;
  public startTime: any;
  public timefrom: any;
  public driverName: any;
  public Van_ID: string;
  public getdate: any;
  public date: any = new Date();
  public ViewAll: boolean;
  public ShowOnly: boolean;
  public isAllData: boolean;
  public Accessright: boolean;
  public requestId: string;
  public tblID: any;
  public emp_ID: string;
  public leg: any;
  public etblID: any;
  public deviceWidth: number;
  public van_ID: any;
  public etransID: any;
  public editinsnum: any;
  public FlatRatetblID: any;
  public transid: any;
  public tripDate: any;
  public locname: any;
  public tophy: any;
  public city: any;
  public state: any;
  public zip: any;
  public cllocname: any;
  public fromaddress: any;
  public fromaddress2: any;
  public city1: any;
  public zip1: any;
  public state1: any;
  onboardUserName: string;
  public altAddress1: any;
  public altAddress2: any;
  public altCity: any;
  public altHomeType: any;
  public altState: any;
  public altZip: any;
  public multipleriders: any;
  public loginUser: any;
  public globalAgencyId: any = "00000000-0000-0000-0000-000000000000";
  public logginedUserName: any;
  public clientonboard: any;
  public agencyName: any = null;

  public LocationName: any = null;
  public agencyPhone: any = null;
  public agencyLogo: any = null;
  public loading: boolean = false;
  public roleId: string = "ADMIN";
  public listId: any = 3;
  public email: string;
  public deleteErr: string;
  public ErrorBool: boolean = false;
  public userSelectedRole: string = "";
  public globalAgencyDropdown: any = "";
  public employeeSubmitSave: any
  public employeeOnboardDocumentId: string;
  public submitLovCode = ''
  public globalLocationId: any = null;
  locationData: any = 0;
  public isViewClientPageDis: boolean = false;
  public isViewClientBudget: boolean = false;
  LoginUserType: any;
  isCheckOperationDashboardRecord: boolean = false;
  globalCLaimStatus: any = null;
  globalClaimType: boolean = null;
  public isViewClientPageEna: boolean = false;
  employeetoAgreementEmit: boolean = false
  public loginusername: any;
  checkProgressTimesheet: boolean = null;
  checkProgressPurchase: boolean = null;
  checkProgressTransaction: boolean = null;
  checkidleTime: boolean = true;
  checkidlePurchase: boolean = true;
  checkidleTransaction: boolean = true;
  isUMPI: boolean = null
  refreshTokenString: any;
  selectAgencyCode: any;
  isServiceWorkersEnabled: boolean = false;

  
  LovValues: any = [];
  LocationValues: any = [];
  ServiceValues: any = [];
  UserValues: any = [];
  ServiceDropDownValues: any = [];
  MasterServiceDropDownValues: any = [];
  ServicePayrateList:any=[];
  globalLoc:any=[];
  globalServiceDropdown:any=[]
  globalServiceCodeDropdown:any=[]
  
  
  claimsFromDate:any;
  claimsToDate:any;
  isglobal30DaysOlder:boolean=null;
  checkidle: boolean = true;
  checkclaimProgress: boolean = null;
  coverLetterDetails:any;
  CompanyDropDownValues:any=[];
  globalClearinghouse:any=[];
  globalCommonGetGPList:any=[];
    PayorList:any=[];
    isglobalFromorPreparedDate:boolean=null;
  powerbiToken: string; 
  InactiveClientId: any = null;
  InactiveClientTimesheets: boolean = false;
  InactiveClientTimesheetsFromDate: any = null;
  InactiveClientTimesheetsToDate: any = null;
  contactTypes: any = [];
  contactHouseCaseTypelid: number;
  serviceType: any = [];
  referralStartdate:any;
  referralEnddate:any;
  referralStatus:any;
  referralAge:any;
  dashtoreferral:boolean=false;

  
  isClientNewTab:boolean=false;
   isTicketNewTab:boolean=false;
  
  searchClientText:string="";
  searchClientStatus:string=""
  ccxWidget:boolean=false;
  isSDPtoEvent : boolean = false;
  clientName : string;
  referralId : string = "00000000-0000-0000-0000-000000000000" ;
  referralcontact : boolean = false;
  referralTab : boolean = false;
  EventClientid : string =  "00000000-0000-0000-0000-000000000000" ;
  isMaximized: boolean = false;
  isValidCcxAccessKey : boolean;
  businessStartTime : string;
  businessEndTime : string;
  fullName: string;
  env :any;
  employeeId:string;
  constructor(private ngxService: NgxUiLoaderService,public update: SwUpdate, public http: HttpClient, public route: Router, public general: GeneralService, private router: Router,
    public commonservice: CommonHttpService, public toasterService: ToastrService, public iframeCommunicationService: IframeCommunicationService) {
    this.getFeaturesJson();
    this.env = environment
  }

  ngOnInit() {
  }

  Adddata(data) {
    if (data.onboardingId == null || data.onboardingId == undefined) {
      this.authtoken = data.tokenString;
      this.onboardingId = null;
    }
    else {
      this.authtoken = data.accessToken;
      this.onboardingId = data.onboardingId
    }

    this.LoginUserType = data.LoginUserType;
    this.logginedUserName = data.userName;
    this.agencyLogo = data.agencyLogo;
    this.agencyName = data.agencyName;
    this.agencyPhone = data.phone;
    this.userID = data.userId;
    this.globalAgencyId = data.agencyId == "00000000-0000-0000-0000-000000000000" ? null : data.agencyId;
    if (data.userId != "00000000-0000-0000-0000-000000000000" && data.userId != null && data.userId != undefined) {
    }
    if (this.agencyPhone != null) {
      this.agencyPhone = this.general.converPhoneGoogleLib(this.agencyPhone);
    }

    if (data.menuList != undefined && data.menuList != null) {
      this.AddMenuItems(data.menuList);
    }
  }

  AddMenuItems(data) {
    let menu: any = []
    let i: number = 1;
    data.forEach(element => {
      let temp: any = {}
      temp.id = i;
      temp.title = element.title;
      temp.routerLink = element.link;
      temp.href = null;
      temp.icon = element.icon;
      temp.target = null;

      temp.parentId = 0;

      if (element.children != null && element.children.length > 0) {
        let j: number = i + 1;
        element.children.forEach(element => {
          let submenu: any = {}
          submenu.id = j;
          submenu.title = element.title;
          submenu.routerLink = element.link;
          submenu.href = null;
          submenu.icon = element.icon;
          submenu.target = null;
          submenu.hasSubMenu = false;
          submenu.parentId = i;

          menu.push(submenu);
          j++;
        });
        i = j - 1;
        temp.hasSubMenu = true;
      }
      else {
        temp.hasSubMenu = false;
      }
      menu.push(temp);
      i++;
    });
    this.sideMenuItems = menu;
    localStorage.setItem("CFSS_menulist", JSON.stringify(this.sideMenuItems));
  }
  Addagencydata(data) {
    this.globalHeadAgencyId = data.agencyId;
    this.agencyId = data.agencyId;
    this.agencyId = data.agencyId
    this.selectedAgencyDropdown = (this.globalHeadAgencyId == '00000000-0000-0000-0000-000000000000') ? '' : this.globalHeadAgencyId;
    this.agencyLogo = data.agencyLogo;
    this.agencyName = data.agencyName;
    this.selectedAgencyDropdown = data.agencyName;
    this.agencyPhone = data.phone;
    if (this.agencyPhone != null) {
      this.agencyPhone = this.general.converPhoneGoogleLib(this.agencyPhone);
    }
    this.globalAgencyId = data.agencyId;
  }


  agencyList() {
   let agencyData = JSON.parse(localStorage.getItem("CFSS_agencydetails"));
    if (agencyData?.userId == null || agencyData?.userId == undefined || agencyData?.userId == "00000000-0000-0000-0000-000000000000") {
      this.roleId = agencyData.roleId;
    }
    else {
      this.roleId = localStorage.getItem("CFSS_role");
    }
  }
  refreshAgencyDetails(selectedAgencyId) {
    this.globalAgencyId = selectedAgencyId;
    this.globalHeadAgencyId = selectedAgencyId;
    var agency_Id: string = "00000000-0000-0000-0000-000000000000";
    let url = "api/Agency/OverallAgencyInfo?";
    let myparams = new URLSearchParams();
    if (selectedAgencyId == '' || selectedAgencyId == null || selectedAgencyId == "00000000-0000-0000-0000-000000000000") {
      myparams.append("agencyId", agency_Id);
    }
    else {
      myparams.append("agencyId", selectedAgencyId);
    }
    this.http.get(url + myparams).subscribe((data: any) => {
      if (data != null) {
        localStorage.setItem("CFSS_agencyNames ", JSON.stringify(data));
        this.agencyLogo = data.agencyLogo;
        this.agencyName = data.agencyName;
        this.selectAgencyCode = data.agencyCode;
        if (data.phone != null) {
          data.phone = this.general.converPhoneGoogleLib(data.phone);
          this.agencyPhone = this.general.converPhoneGoogleLib(data.phone);
        }
        else {
          this.agencyPhone = null;
        }
        data.agencyId = selectedAgencyId;
        this.globalAgencyId = selectedAgencyId;
        if (selectedAgencyId == '' ){
          this.globalAgencyId = "00000000-0000-0000-0000-000000000000";
        }
        localStorage.setItem("CFSS_globalagencydetails", JSON.stringify(data));
        this.route.routeReuseStrategy.shouldReuseRoute = () => false;
        this.route.onSameUrlNavigation = 'reload';
        this.route.navigate(['/agency']);
      }
      else {
        this.agencyLogo = null;
        this.agencyName = null;
        this.agencyPhone = null;
        this.globalAgencyId = '';
        let data: any = "";
        localStorage.setItem("CFSS_globalagencydetails", JSON.stringify(data));
        this.route.navigateByUrl('/agency');
        this.route.routeReuseStrategy.shouldReuseRoute = () => false;
        this.route.onSameUrlNavigation = 'reload';
        this.route.navigate(['/agency']);
      }
    }
    )
  }

  checkforlogout() {
    let val = this.router.url;
   

    if (val != "/Client") {
      this.CxCustomerName=null;
      this.CxCustomerId=null;
    }
    if (!(val == "/employee" || val == "/operational-dashboard ")) {
      this.globalemployee = '00000000-0000-0000-0000-000000000000';
    }
    if (!(val == "/client-batch" || val == "/client-report")) {

    }
    if (val != "/batch") {
      this.globalclaimfilter = null;
    }
    let checkforlogindetails = localStorage.getItem("CFSS_login");

   
  }

  checkforonBoardLogout() {
    let onboardCredentials = localStorage.getItem("CFSS_login");
   
    if (onboardCredentials == null) {
      let onboardagencycode = localStorage.getItem("CFSS_onboardagencycode");
      let logintype = localStorage.getItem("CFSS_onboardtype");
      this.CFSS_onboardagencycode = onboardagencycode;
      this.LoginTypeFields = logintype;
      if (this.LoginTypeFields == 'employee') {
        this.router.navigateByUrl("/onboarding/employee/" + this.CFSS_onboardagencycode);
        this.LoginTypeFields = ""
      }
      else {
        this.LoginTypeFields = ""
        this.router.navigateByUrl("/onboarding/client/" + this.CFSS_onboardagencycode);
      }
      this.CFSS_onboardagencycode = ""

    }
  }

  isalpha(c) {
    return (((c >= 'a') && (c <= 'z')) || ((c >= 'A') && (c <= 'Z')));
  }

  isdigit(c) {
    return ((c >= '0') && (c <= '9'));
  }

  isalnum(c) {
    return (this.isalpha(c) || this.isdigit(c));
  }

  refreshLocationDetails(selectedLocationId) {
    this.globalLocationId = selectedLocationId;
    if (this.globalLocationList.length > 0) {
      if (selectedLocationId != null && selectedLocationId != undefined && selectedLocationId != '') {
        let location = this.globalLocationList?.filter(a => a.Key == selectedLocationId)[0].Value;
        this.LocationName = location;
      }
    }

    localStorage.setItem("CFSS_location", JSON.stringify(selectedLocationId));
    this.reloadComponent();
  }
  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }
  getFeaturesJson() {
    this.globalFeatures = [];
    this.commonservice.getFeaturesJSON().subscribe((data: any) => {
      this.globalFeatures = data;
    })
  }
  getFeaturesByName(Name) {
    var enable
    this.globalFeatures.forEach(element => {
      if (element.featureName == Name) {
        enable = element.enabled;
      }
    });
    return enable;
  }
  getOverallAgencyDropDown() {
    let url = "api/Agency/OverallAgency";
    this.http.get(url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      localStorage.setItem("CFSS_agencyNames", JSON.stringify(data));
      this.globalAgencyDropDown = data;
      console.log(this.globalAgencyDropdown,"agenyc");
      
    },
      err => {
      })
  }

  //.........assignToken............................................................................................
  assignToken(data) {
    this.authtoken = data.accessToken;
   
  }
  // AddAgencyDropdown
  AddAgencyDropdown(data) {
    this.globalAgencyDropDown = data;
    this.ngAgencyDropDown = this.globalAgencyDropDown;
    this.ngAgencyDropDown.forEach(a => a.id = a?.id?.toString());
    this.globalAgencyDropdown = this.globalAgencyId == '00000000-0000-0000-0000-000000000000' ? '' : this.globalAgencyId;
  }
  //agency& user Details//////
  getAgencyDetails(agencyValues) {
    this.agencyId = agencyValues.agencyId;
    this.agencyCode = agencyValues.agencyCode;
    this.globalroleName = agencyValues.roleName;
    this.logginedUserName = agencyValues.userName;
    this.agencyLogo = agencyValues.agencyLogo;
    this.agencyName = agencyValues.agencyName;
    this.agencyPhone = agencyValues.phone;
    this.userID = agencyValues.userId;
    this.globalAgencyId = agencyValues.agencyId;
    if (agencyValues.userId != '00000000-0000-0000-0000-000000000000' && agencyValues.userId != null && agencyValues.userId != undefined) {

    }

    this.roleId = agencyValues.roleId;

    if (this.agencyPhone != null) {
      this.agencyPhone = this.general.converPhoneGoogleLib(this.agencyPhone);
    }
  }
  // ..................................RefreshT0ken.........................................................................
  refreshToken(): Promise<void> {
    return new Promise((resolve, reject) => {
      let url = "api/Auth/refreshToken";
      this.refreshTokenString = JSON.parse(localStorage.getItem("CFSS_refreshtoken "));
      let refreshpayload = {
        refreshToken: this.refreshTokenString,
        accessToken: this.authtoken
      }
      // refresh token and access token not set in the body ,because  it will set   in  interceptor. cookie will be automatically set in interceptor.
      this.http.post(url, refreshpayload).subscribe((response: any) => {
        this.authtoken = response.accessToken;
        this.refreshTokenString = response.refreshToken;
        this.isassignboolean=true;
        localStorage.setItem("CFSS_login", JSON.stringify(response));
        localStorage.setItem("CFSS_refreshtoken ", JSON.stringify(response.refreshToken));
        resolve(response)
      },
        (err: HttpErrorResponse) => {
          console.log("logout from cfss")
          window.postMessage("stop", "*");
          this.toasterService.error("Your Session Got Expired, Please Login", 'Session Expired');
          this.globalHeadAgencyId = "00000000-0000-0000-0000-000000000000";
          Object.keys(localStorage).forEach(key => {
              if (!key.toLowerCase().includes('grid')) {  // 🔒 keep grid state
                localStorage.removeItem(key);
              }
            });          
          this.agencyLogo = null;
          this.agencyName = null;
          this.agencyPhone = null;
          this.globalAgencyId = '';
          this.globalLocationId = '';
          this.selectedAgencyDropdown = "";
          this.selectedLocationDropdown = '';
          this.ngLocationDropDown = [];
          this.userRoleDropDown = []
          this.userSelectedRole = ""
          this.globalAgencyDropdown = "";

          this.LovValues = [];
          this.LocationValues = [];
          this.ServiceValues = [];
          this.UserValues = [];
          this.refreshTokenString = null;
          this.ServiceDropDownValues = [];
          this.MasterServiceDropDownValues=[];
          this.ServicePayrateList=[];
          this.CompanyDropDownValues=[];
          this.globalLoc=[];
          this.PayorList=[];
          this.globalClearinghouse=[];
          this.globalCommonGetGPList=[];
          this.router.navigateByUrl("/login");

          reject(err);
        });
    });
  }
  scheduleRefresh() {
    this.refreshSubscription = interval(1000 * 60 * 25).subscribe(() => {
      this.refreshToken().catch(() => {
        this.refreshSubscription?.unsubscribe();
      });
    });
  }
  // for Onboarding Refresh token
  OnboardingrefreshToken(): Promise<void> {
    return new Promise((resolve, reject) => {
      let url = "api/Auth/refreshToken";
      let refreshpayload = {
        refreshToken: this.refreshTokenString,
        accessToken: this.authtoken
      }
      // refresh token and access token not set in the body ,because  it will set   in  interceptor. cookie will be automatically set in interceptor.
      this.http.post(url, refreshpayload).subscribe((response: any) => {
        this.authtoken = response.accessToken;
        this.refreshTokenString = response.refreshToken;
        this.LoginUserType = 'Onboard';
        response.LoginUserType = 'Onboard';
        localStorage.setItem("CFSS_login", JSON.stringify(response));
        this.isassignboolean = true;
       
        resolve(response)
      },
        (err: HttpErrorResponse) => {
          console.log("logout from cfss")
          window.postMessage("stop", "*");
          this.toasterService.error("Your Session Got Expired, Please Login", 'Session Expired');
          this.globalHeadAgencyId = "00000000-0000-0000-0000-000000000000";
          this.agencyLogo = null;
          this.agencyName = null;
          this.agencyPhone = null;
          this.globalAgencyId = '';
          this.globalLocationId = '';
          this.selectedAgencyDropdown = "";
          this.selectedLocationDropdown = '';
          this.ngLocationDropDown = [];
          this.userRoleDropDown = []
          this.refreshTokenString = null;
          this.userSelectedRole = ""
          this.globalAgencyDropdown = "";
          this.LogoutFunction();
          Object.keys(localStorage).forEach(key => {
            if (!key.toLowerCase().includes('grid')) {  // 🔒 keep grid state
              localStorage.removeItem(key);
            }
          });
          reject(err);
        });
    });
  }
  OnboardingscheduleRefresh() {
    this.refreshSubscription = interval(1000 * 60 * 25).subscribe(() => {
      this.OnboardingrefreshToken().catch(() => {
        this.refreshSubscription?.unsubscribe();
      });
    });
  }
  assignOnboardingToken(data) {
    this.authtoken = data.accessToken;
  }

  onboardingdetails(list) {
    this.onboardingId = list.onboardingId;
    this.LoginUserType = list.LoginUserType;
  }

  onboardsideMenus(data) {
    let menu: any = []
    let i: number = 1;
    data.forEach(element => {
      let temp: any = {}
      temp.id = i;
      temp.title = element.title;
      temp.routerLink = element.routerLink;
      temp.href = null;
      temp.icon = element.icon;
      temp.target = null;
      temp.parentId = '00000000-0000-0000-0000-000000000000';
      if (element.children != null && element.children.length > 0) {

        let j: number = i + 1;
        element.children.forEach(element => {
          let submenu: any = {}
          submenu.id = j;
          submenu.title = element.title;
          submenu.routerLink = element.routerLink;
          submenu.href = null;
          submenu.icon = element.icon;
          submenu.target = null;
          submenu.hasSubMenu = false;
          submenu.parentId = i;

          menu.push(submenu);
          j++;
        });
        i = j - 1;
        temp.hasSubMenu = true;
      }
      else {
        temp.hasSubMenu = false;
      }
      menu.push(temp);
      i++;
    });
    this.sideMenuItems = menu;
    localStorage.setItem("CFSS_menulist", JSON.stringify(this.sideMenuItems));
  }

  LogoutFunction() {
    this.ngxService.start();
    this.agencyLogo = null;
    this.agencyName = null;
    this.agencyPhone = null;
    this.globalAgencyId = null;
    this.globalLocationId = null;
    this.globalAgencyDropdown = null;
    this.selectedLocationDropdown = '';
    this.selectedAgencyDropdown = '';
    this.ngLocationDropDown = [];
    this.userRoleDropDown = []
    let onboardagencycode = localStorage.getItem("CFSS_onboardagencycode");
    let logintype = localStorage.getItem("CFSS_onboardtype");
    this.CFSS_onboardagencycode = onboardagencycode;
    this.LoginTypeFields = logintype;
    if (this.CFSS_onboardagencycode != "" && this.CFSS_onboardagencycode != null && this.CFSS_onboardagencycode != undefined) {
      if (this.LoginTypeFields == 'employee') {
        this.router.navigateByUrl("/onboarding/employee/" + this.CFSS_onboardagencycode);
        this.LoginTypeFields = ""
      }
      else {
        this.LoginTypeFields = ""
        this.router.navigateByUrl("/onboarding/client/" + this.CFSS_onboardagencycode);
      }
      this.ngxService.stop();
      this.CFSS_onboardagencycode = ""
    } else {
      if (this.agencyCode != 'SUPERADMIN' && this.OnboardingLoginType == 'agencyLogin') {
        console.log("logout from cfss")
        window.postMessage("stop", "*");
      }
      setTimeout(() => {
        this.router.navigateByUrl("/login");
        this.ngxService.stop();
      }, 3000)

    }
    Object.keys(localStorage).forEach(key => {
    if (!key.toLowerCase().includes('grid')) {  // 🔒 keep grid state
      localStorage.removeItem(key);
    }
  });
    this.userSelectedRole = ""
    this.globalHeadAgencyId = "00000000-0000-0000-0000-000000000000";
    this.refreshSubscription?.unsubscribe();
  }

  //..............................................getDateTimeString...................................................
  getDateTimeString(date: any): string {
    var tzoffset = (new Date(date)).getTimezoneOffset() * 60000; //offset in milliseconds
    return (new Date(new Date(date).getTime() - tzoffset)).toISOString().slice(0, -1);
  }

  getDateTimeStringWithOffset(date: any): string {
    const localDate = new Date(date);

    // Extract local date components
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, '0'); // Month is 0-based
    const day = String(localDate.getDate()).padStart(2, '0');
    const hours = String(localDate.getHours()).padStart(2, '0');
    const minutes = String(localDate.getMinutes()).padStart(2, '0');
    const seconds = String(localDate.getSeconds()).padStart(2, '0');
    const milliseconds = String(localDate.getMilliseconds()).padStart(3, '0');

    // Get timezone offset in minutes (negative means ahead of UTC)
    const offsetMinutes = -localDate.getTimezoneOffset(); // Negate to get correct sign
    const absOffsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
    const absOffsetMinutes = Math.abs(offsetMinutes) % 60;

    // Format timezone offset as ±HH:mm
    const offsetSign = offsetMinutes >= 0 ? "+" : "-";
    const formattedOffset = `${offsetSign}${String(absOffsetHours).padStart(2, '0')}:${String(absOffsetMinutes).padStart(2, '0')}`;

    // Construct final format (YYYY-MM-DDTHH:mm:ss.SSS±HH:mm)
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}${formattedOffset}`;
  }
  

  //........................................................GetLocationDropDown...............................................
  GetLocationDropDown() {
    let url = "api/Location/GetLocationDropDown";
    this.http.get(url).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.globalLocationList = data;
      let Loc = JSON.parse(localStorage.getItem("CFSS_location"));
      if (this.globalLocationList.length > 0) {
        if (Loc != null && Loc != undefined && Loc != '') {
          let location = this.globalLocationList?.filter(a => a.Key == Loc)[0].Value;
          this.LocationName = location;
        }
      }
    },
      err => {
      })
  }
  // ...................................................getLocation for userdropdown............................................

  userlocation: any;
  getLocationforagencyuser() {
    let UserType = localStorage.getItem("agencyLogin");
    if (UserType != "SUPERADMIN" && this.LoginTypeFields != 'employee' && !this.isClientOnboard) {
      let url = "api/User/GetLocationDropDownForUSER?";
      return this.http.get(url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.userlocation = data;
        this.globalLocationList = this.userlocation;
      })
    }
  }
  //........................................checkClaimCreationProgressForTimesheet............................................
  checkClaimCreationProgressForTimesheet(id) {
    if (id != null && id != undefined && id != '') {
      let url = "api/Claims/checkClaimCreationProgress?";
      let myParams = new URLSearchParams();
      myParams.append("progressId", id)
      this.http.get(url + myParams).pipe().subscribe((data: any) => {
        this.checkProgressTimesheet = data;
        this.checkidleTime = false;
        if (data == true) {
          setTimeout(() => {
            this.checkClaimCreationProgressForTimesheet(id);
          }, 5000);
        }
        else {
          clearInterval(this.interval);
          id = null
        }
      },
      )
    }
  }
  //..........................scheduleClaimProgressForTimesheet........................................................
  scheduleClaimProgressForTimesheet(id) {
    this.interval = setTimeout(() => {
      this.checkClaimCreationProgressForTimesheet(id);
    }, 1000);
  }

  //........................................checkClaimCreationProgressForPurchase............................................
  checkClaimCreationProgressForPurchase(id) {
    if (id != null && id != undefined && id != '') {
      let url = "api/Claims/checkClaimCreationProgressPurchase?";
      let myParams = new URLSearchParams();
      myParams.append("progressId", id)
      this.http.get(url + myParams).pipe().subscribe((data: any) => {
        this.checkProgressPurchase = data;
        this.checkidlePurchase = false;
        if (data == true) {
          setTimeout(() => {
            this.checkClaimCreationProgressForPurchase(id);
          }, 5000);
        }
        else {
          clearInterval(this.interval);
          id = null
        }
      },
      )
    }
  }
  //..........................scheduleClaimProgressForPurchase........................................................
  scheduleClaimProgressForPurchase(id) {
    this.interval = setTimeout(() => {
      this.checkClaimCreationProgressForPurchase(id);
    }, 1000);
  }
  //........................................checkClaimCreationProgressForTransaction............................................
  checkClaimCreationProgressForTransaction(id) {
    if (id != null && id != undefined && id != '') {
      let url = "api/Claims/checkClaimCreationProgressTransaction?";
      let myParams = new URLSearchParams();
      myParams.append("progressId", id)
      this.http.get(url + myParams).pipe().subscribe((data: any) => {
        this.checkProgressTransaction = data;
        this.checkidleTransaction = false;

        if (data == true) {

          setTimeout(() => {
            this.checkClaimCreationProgressForTransaction(id);
          }, 5000);

        }
        else {
          clearInterval(this.interval);
          id = null
        }
      },
      )
    }
  }

    //........................................checkClaimCreationProgress............................................
    checkClaimCreationProgress() {
      let progressId = localStorage.getItem("ac_progressId");
      if (progressId != null && progressId != undefined && progressId != '') {
        let url = "api/BillingClaim/checkClaimCreationProgress?";
        let myParams = new URLSearchParams();
        myParams.append("progressId", progressId)
        this.http.get(url + myParams).pipe().subscribe((data: any) => {
          this.checkclaimProgress = data;
          this.checkidle = false;
          if (data == true) {
  
            setTimeout(() => {
              this.checkClaimCreationProgress();
            }, 5000);
  
          }
          else {
  
            clearInterval(this.interval);
            localStorage.removeItem("ac_progressId");
          }
        },
        )
      }
    }
    //..........................scheduleClaimProgress........................................................
    scheduleClaimProgress() {
      this.interval = setTimeout(() => {
        this.checkClaimCreationProgress();
      }, 1000);
  
  
    }
  //..........................scheduleClaimProgressForTransaction........................................................
  scheduleClaimProgressForTransaction(id) {
    this.interval = setTimeout(() => {
      this.checkClaimCreationProgressForTransaction(id);
    }, 1000);
  }

  checkForAppUpdateAvailable() {
   
    this.update.versionUpdates.subscribe(event =>
      this.versionCheck(event));
  }
  //..........................versionCheck........................................................
  versionCheck(event) {
    if(event?.type === "VERSION_READY"){
      this.isServiceWorkersEnabled = true;
    }
  }
  async getAgencySetting(): Promise<void> {
     return new Promise((resolve, reject) => {
      let url;
      if(this.OnboardingLoginType =='onboardLogin')
        {
           url = "api/Client_Settings/GetAgencySettingsForGlobalConfig";
        }
        else{
  
           url = "api/Settings/GetAgencySettingsForGlobalConfig";
        }
    // let myParams = new URLSearchParams();
    // myParams.append("AgencyId", this.agencyId)
       this.http
       .get(url)
       .pipe(takeUntil(this.onDestroy$))
       .subscribe((data: any) => {
        console.log(data);
         this.cxTenantDetails = data;
         localStorage.setItem("CFSS_CXTenantDetails", JSON.stringify(data))
         console.log(data)
         this.ccxWidget = this.cxTenantDetails.isCCXWidget;
         this.isValidCcxAccessKey = this.cxTenantDetails.isValidCcxAccessKey;
         console.log(this.isValidCcxAccessKey)
         this.businessStartTime = this.cxTenantDetails.businessStartTime
         this.businessEndTime = this.cxTenantDetails.businessEndTime;
         this.fullName = this.cxTenantDetails.userFullName;
          if(this.agencyCode!='SUPERADMIN' && this.OnboardingLoginType == 'agencyLogin' && this.env.isWidget && this.ccxWidget){
            this.loadAgentWidget();
          }
          if(  this.agencyCode!='SUPERADMIN' && this.OnboardingLoginType == 'onboardLogin' && environment?.isWidget && this.ccxWidget){
            this.loadCustmerWidget();
          }
         resolve(data)
       });
     });
    }



  getLocation() {
    if (this.agencyCode != 'SUPERADMIN' && this.LoginUserType.toUpperCase() != 'ONBOARD') {
      let url = "api/User/GetLocationDropDownForUSER?";

      return this.http.get(url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.userlocation = data;
        this.globalLocationList = this.userlocation;
      })
    }
  }

    //..........................preventforSpace........................................................
    preventforSpace(event) {

      if (event.keyCode == 32) {
        event.preventDefault();
      }
    }

    emailRegexValidator(): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
        const email = control.value;
        // Check if the email contains '@' symbol
        if (email && !email.includes('@')) {
          return { invalidEmail: true };
        }
        return null;
      };
    }
    loadAgentWidget(){
    const script = document.createElement('script');
    script.src = environment?.agentWidgeturl;
    script.async = true;
    script.onload = () => {
      if(this.agencyCode!='SUPERADMIN' && this.OnboardingLoginType == 'agencyLogin' && this.env.isWidget && this.ccxWidget)
        {
          console.log(this.agencyCode)
        const agentDetails = {
          AppName: "CFSS",
          AgentAppCode: "CFSS_" + this.agencyCode,
          AgentType: "EMPLOYEE",
          AgentID: this.userID ?? "",
          AgentName: this.fullName ?? "",
          AgentDetails: JSON.stringify({}) ?? "",
        };
        window.postMessage(
          {
            type: "Init",
            params: agentDetails,
          },
          "*" 
        );

        }
    }
    script.onerror = (err) => {
      console.error("Widget script failed to load ", err);
    };
    document.body.appendChild(script);
    }

    loadCustmerWidget() {
    const script = document.createElement('script');
    script.src = environment?.customerWidgeturl;
    script.async = true;
    script.onload = () => {
      if(  this.agencyCode!='SUPERADMIN' && this.OnboardingLoginType == 'onboardLogin' && environment?.isWidget && this.ccxWidget)
        {
        const customerWidgetDetails = {
          AppColor:"#00786a",
          CustomerAppCode: "CFSS_"+this.CFSS_onboardagencycode,
          CustomerType: "CLIENT",
          CustomerId: this.cfssLoginEntityId,
          CustomerName: this.fullName ?? "",
          CustomerDetails: JSON.stringify({}) ?? "",
        };
        window.postMessage(
          {
            type: "Init",
            params: customerWidgetDetails,
          },
          "*" 
        );

        }
    };
    script.onerror = (err) => {
      console.error("Widget script failed to load ", err);
    };
    document.body.appendChild(script);
  }

    clearGridIdLocalStorage(gridConfigs: {localStorageKey: string, expectedColumns: number}[]): void {
    gridConfigs?.forEach(config => {
      const gridState = localStorage.getItem(config?.localStorageKey);
      if (gridState) {
        try {
          const parsedState = JSON.parse(gridState);
           // ✅ Reset page settings
    if (parsedState.pageSettings) {
      parsedState.pageSettings.pageSize = 10;
      parsedState.pageSettings.currentPage = 1;
      
      // ✅ Save back to localStorage
      localStorage.setItem(config?.localStorageKey, JSON.stringify(parsedState));
    }
          const persistedColumnCount = parsedState?.columns?.length || 0;
          if (persistedColumnCount !== config?.expectedColumns) {
            console.log("Clearing localStorage for key:", config?.localStorageKey);
            localStorage.removeItem(config?.localStorageKey);
          }
        } catch (error) {
          localStorage.removeItem(config?.localStorageKey);
        }
      }
    });
  }

}

